import type { RouterConfig } from '@nuxt/schema'
import {
  isListScrollPath,
  isProductDetailPath,
  markRouterNavigation,
} from '~/utils/listScrollNavigation'

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    markRouterNavigation(savedPosition)

    // Bar filter steps stay on the same list page: keep the position going forward,
    // show the top of the list when moving through history. Scoped to list-scroll
    // pages so an unrelated same-path replace elsewhere (e.g. pages/index.vue
    // stripping a token param) isn't affected.
    if (from && to.path === from.path && !to.hash && isListScrollPath(to.path)) {
      return savedPosition ? { top: 0 } : false
    }

    if (savedPosition) {
      // List pages restore scroll after products re-render; avoid early jump.
      if (isListScrollPath(to.path)) {
        return false
      }
      return savedPosition
    }

    if (to.hash) {
      return { el: to.hash, top: 0 }
    }

    // Keep list scroll until the product detail page mounts and scrolls itself.
    if (from && isListScrollPath(from.path) && isProductDetailPath(to.path)) {
      return false
    }

    return { top: 0 }
  },
}
